import script from "./BaseTemplateItemTransformSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplateItemTransformSetting.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplateItemTransformSetting.vue?vue&type=style&index=0&id=67bd19d8&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67bd19d8"]])

export default __exports__